__turbopack_context__.v({
  "address": "InternalTransactionsPage-module__niJz9W__address",
  "addressRow": "InternalTransactionsPage-module__niJz9W__addressRow",
  "age": "InternalTransactionsPage-module__niJz9W__age",
  "contractBadge": "InternalTransactionsPage-module__niJz9W__contractBadge",
  "controls": "InternalTransactionsPage-module__niJz9W__controls",
  "emptyState": "InternalTransactionsPage-module__niJz9W__emptyState",
  "errorStatus": "InternalTransactionsPage-module__niJz9W__errorStatus",
  "errorText": "InternalTransactionsPage-module__niJz9W__errorText",
  "header": "InternalTransactionsPage-module__niJz9W__header",
  "link": "InternalTransactionsPage-module__niJz9W__link",
  "pageButton": "InternalTransactionsPage-module__niJz9W__pageButton",
  "pageButtonActive": "InternalTransactionsPage-module__niJz9W__pageButtonActive",
  "pagination": "InternalTransactionsPage-module__niJz9W__pagination",
  "skeleton": "InternalTransactionsPage-module__niJz9W__skeleton",
  "skeletonShimmer": "InternalTransactionsPage-module__niJz9W__skeletonShimmer",
  "table": "InternalTransactionsPage-module__niJz9W__table",
  "tableContainer": "InternalTransactionsPage-module__niJz9W__tableContainer",
  "title": "InternalTransactionsPage-module__niJz9W__title",
  "typeBadge": "InternalTransactionsPage-module__niJz9W__typeBadge",
  "value": "InternalTransactionsPage-module__niJz9W__value",
});
